import { ref } from 'vue'

// Toast notification store (simple Pinia-less approach)
export const toasts = ref([])

let toastId = 0

export function showToast(message, type = 'info', duration = 4000) {
  const id = toastId++
  const toast = {
    id,
    message,
    type, // 'success', 'error', 'info', 'warning'
  }

  toasts.value.push(toast)

  if (duration > 0) {
    setTimeout(() => {
      removeToast(id)
    }, duration)
  }

  return id
}

export function removeToast(id) {
  const idx = toasts.value.findIndex(t => t.id === id)
  if (idx > -1) {
    toasts.value.splice(idx, 1)
  }
}

export function showSuccess(message, duration = 4000) {
  return showToast(message, 'success', duration)
}

export function showError(message, duration = 6000) {
  return showToast(message, 'error', duration)
}

export function showWarning(message, duration = 5000) {
  return showToast(message, 'warning', duration)
}

export function showInfo(message, duration = 4000) {
  return showToast(message, 'info', duration)
}
